function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "icon_focused icon_selected_stroke12",
  d: "M6.5 13C28.4355 13 35.0161 13 40.5 13",
  stroke: "#8AC341",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 10"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d4)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 13,
  r: 4,
  transform: "rotate(90 23 13)",
  fill: "white"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon_focused",
  cx: 23,
  cy: 13,
  r: 6,
  transform: "rotate(90 23 13)",
  stroke: "#8AC341",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 4"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon_selected",
  cx: 23,
  cy: 13,
  r: 8.5
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "icon_selected_stroke5",
  d: "M6 13C27.9355 13 34.5161 13 40 13",
  stroke: "#373A3C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 13,
  r: 4,
  transform: "rotate(90 23 13)",
  fill: "white"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon_selected",
  cx: 23,
  cy: 13,
  r: 6,
  transform: "rotate(90 23 13)",
  fill: "#8ac341"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon_unselected",
  cx: 23,
  cy: 13,
  r: 4,
  transform: "rotate(90 23 13)",
  stroke: "#373A3C",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon_selected",
  cx: 23,
  cy: 13,
  r: 6,
  transform: "rotate(90 23 13)",
  stroke: "#373A3C",
  strokeWidth: 4
}));

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d4",
  x: 8,
  y: 0,
  width: 30,
  height: 30,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d1",
  x: 11,
  y: 3,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgNeutralSignalIcon = function SvgNeutralSignalIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 30,
    viewBox: "0 0 47 30",
    fill: "none",
    className: "svgIcon",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNeutralSignalIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/neutral-signal-icon.fa4cba86.svg";
export { ForwardRef as ReactComponent };